import { ContentPluginRootState } from 'editor/src/component/DesktopSidebar/TabContents/Plugins/ContentProviderPlugin/store/types';

const getLoadingMore = (state: ContentPluginRootState) => state.data.loadingMore;

export default getLoadingMore;
